export const modalOpenHandler = id => {
  const modal = document.querySelector(`#${id}`);
  if (modal !== null) modal.show();
};

export const modalCloseHandler = () => {
  const modal = document.querySelector('nasu-mf-beacon-modal');
  if (modal !== null) modal.close();
};

// TODO: Abhinav
// Refactor this and move logic to flow-engine.
// Use this function to close the modal, when user tries to dismiss the modal
// and staying on the same screen
export const modalCloseNextModalHandler = closeNextModal => {
  const modal = document.querySelector('nasu-mf-beacon-modal');
  if (modal !== null) {
    modal.close();
    closeNextModal();
  }
};
